import Actions from './actions-types'
import Mutations from './mutations-types'

import api from '@/services/api'

export default {
  async [Actions.SEND_MESSAGE]({dispatch, commit }, data) {
    let isNewSession = false

    if (! data.sessionId) {
      isNewSession = true

      await api.ai_workforce.chat.createUserSession()
        .then((response) => {
          data.sessionId = response.data.session_id

          commit(Mutations.NEW_USER_SESSION, response.data)
        })
    }

    return new Promise((resolve, reject) => {
      api.ai_workforce.chat
        .sendMessage(data)
        .then((response) => {
          const result = {
            sessionId: data.sessionId,
            message: data.message,
            output: response.data[0].output,
          }

          if (isNewSession) {
            dispatch(Actions.GENERATE_USER_SESSION_TITLE, { session_id: data.sessionId })
          }

          resolve(result)
        })
        .catch((error) => reject(error))
    })
  },

  [Actions.GET_CHAT_HISTORY]({ }, params) {
    return new Promise((resolve, reject) => {
      api.ai_workforce.chat
        .getChatHistory(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => reject(error))
    })
  },

  [Actions.GET_USER_SESSIONS]({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.ai_workforce.chat
        .getUserSessions(params)
        .then((response) => {
          const sessions = Object.keys(response.data[0]).length > 0 ? response.data : []

          if (params.offset === 0) {
            commit(Mutations.SET_USER_SESSIONS, sessions)
          } else {
            commit(Mutations.ADD_USER_SESSION, sessions)
          }

          resolve(sessions)
        })
        .catch((error) => reject(error))
    })
  },

  [Actions.REMOVE_USER_SESSION]({ commit }, session) {
    return new Promise((resolve, reject) => {
      api.ai_workforce.chat
        .removeUserSession(session)
        .then((response) => {
          commit(Mutations.REMOVE_USER_SESSION, session)

          resolve(response.data)
        })
        .catch((error) => reject(error))
    })
  },

  [Actions.RENAME_USER_SESSION]({ commit }, session) {
    return new Promise((resolve, reject) => {
      api.ai_workforce.chat
        .renameUserSession(session)
        .then((response) => {
          commit(Mutations.UPDATE_USER_SESSION, session)

          resolve(response.data)
        })
        .catch((error) => reject(error))
    })
  },

  [Actions.GENERATE_USER_SESSION_TITLE]({ commit }, session) {
    return new Promise((resolve, reject) => {
      api.ai_workforce.chat
        .generateUserSessionTitle(session)
        .then((response) => {
          const updatedSession = response.data[0] || {}

          commit(Mutations.UPDATE_USER_SESSION, updatedSession)

          resolve(updatedSession)
        })
        .catch((error) => reject(error))
    })
  },
}
